<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M17.13,22.75a1.3,1.3,0,0,0-2.27,0l-4.35,7.87A.93.93,0,0,0,11.32,32h9.37a.92.92,0,0,0,.8-1.37C20.41,28.67,18.4,25,17.13,22.75Z" />
    <path
        d="M16,0A16.18,16.18,0,0,0,7.24,29.77,1.27,1.27,0,0,0,9,29.31l1-1.83A1.12,1.12,0,0,0,9.61,26a11.72,11.72,0,1,1,12.83,0,1.19,1.19,0,0,0-.42,1.6c.32.58.73,1.31,1.06,1.88a1.08,1.08,0,0,0,.68.54,1.15,1.15,0,0,0,.87-.12A16.17,16.17,0,0,0,16,0Z" />
</svg>